import { createFileRoute } from '@tanstack/react-router'
import { NetworkOperationsDashboard } from '@/components/dashboard/NetworkOperationsDashboard'

import { predefinedQuestionsQueryOptions } from '@/lib/queries'

/**
 * New design: Home/Default route showing the Network Operations dashboard
 */
export const Route = createFileRoute('/_app/')({
  loader: ({ context: { queryClient } }) => {
    void queryClient.prefetchQuery(predefinedQuestionsQueryOptions())
  },
  component: HomePage,
})

function HomePage() {
  return <NetworkOperationsDashboard />
}
